import apiClient from './api';

// Settings → Places (Near me): the hotels and landmarks the public table
// finder's typeahead offers, and the six "Popular" places it shows before
// anything is typed. Towns and villages come from the geography seed and are
// not edited here; they can still be picked as Popular.
const base = (restaurantId, id) =>
  `/users/restaurant/${restaurantId}/finder/landmarks/${id ? `${id}/` : ''}`;

export const finderPlacesService = {
  /** Landmarks (plus the district list the form needs). */
  list: async (restaurantId, { includeInactive = false, q = '' } = {}) => {
    const params = {};
    if (includeInactive) params.include_inactive = 'true';
    if (q) params.q = q;
    const { data } = await apiClient.get(base(restaurantId), { params });
    return { landmarks: data?.results || [], districts: data?.districts || [] };
  },
  create: async (restaurantId, payload) => {
    const { data } = await apiClient.post(base(restaurantId), payload);
    return data?.data;
  },
  update: async (restaurantId, id, payload) => {
    const { data } = await apiClient.put(base(restaurantId, id), payload);
    return data?.data;
  },
  /** Takes the landmark off the typeahead (is_active off); nothing is deleted. */
  deactivate: async (restaurantId, id) => {
    const { data } = await apiClient.delete(base(restaurantId, id));
    return data;
  },
  popular: async (restaurantId) => {
    const { data } = await apiClient.get(`/users/restaurant/${restaurantId}/finder/popular/`);
    return { items: data?.items || [], limit: data?.limit || 6 };
  },
  /** Replace the Popular list; `refs` are 'locality:<id>' / 'landmark:<id>' in display order. */
  setPopular: async (restaurantId, refs) => {
    const { data } = await apiClient.put(`/users/restaurant/${restaurantId}/finder/popular/`, { refs });
    return { items: data?.items || [], limit: data?.limit || 6 };
  },
  /** The public typeahead itself — the same answer a guest gets, used here to pick Popular entries. */
  searchPlaces: async (q) => {
    const { data } = await apiClient.get('/public/places', { params: { q } });
    return data?.data?.items || [];
  },
};
